import React from "react";
import { motion } from "framer-motion";

const items = [
  {
    quote:
      "Heritex shipped our CRM in six weeks — what three other agencies quoted at six months. The work feels considered, not rushed.",
    name: "Ananya Iyer",
    role: "COO, private wealth advisory",
  },
  {
    quote:
      "The team operates like a senior in-house squad. Strategy, design and code all live under one calm Slack channel.",
    name: "Rohan Mehta",
    role: "Founder, B2B SaaS",
  },
  {
    quote:
      "Our internal ops platform finally feels like a product. Their attention to small details changed how my team works every day.",
    name: "Priya Shah",
    role: "Head of Operations",
  },
];

export default function Testimonials() {
  return (
    <section className="relative py-24 md:py-36 bg-[#F5F4F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="caption mb-6">Notes from clients</div>
        <h2 className="font-serif-display text-4xl sm:text-5xl md:text-6xl tracking-tight text-[#1A1A1A] leading-[1.05] max-w-4xl mb-16 md:mb-20">
          Quiet partnerships. <span className="italic">Loud results.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          {items.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className="border-t border-[#1A1A1A]/20 pt-8"
            >
              <span className="font-serif-display text-5xl text-[#1A1A1A]/30 leading-none block mb-2">
                &ldquo;
              </span>
              <blockquote className="font-serif-display text-xl md:text-2xl italic text-[#1A1A1A] leading-snug">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 caption">
                {t.name} <span className="text-[#1A1A1A]/40 ml-2">·</span> {t.role}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
